








































































import {Component, Prop} from 'vue-property-decorator'
import {BridgeNetworks} from '@/model/bridge/types/BridgeNetworks'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {$} from '@/facade'
import {BridgeNetworkHelper} from '@/helpers/BridgeNetworkHelper'

@Component
export default class BridgeTargetSection extends MixinScreenSize {
  @Prop({type: String, required: true}) network!: BridgeNetworks

  get addressComputed() {
    const address = String(
      this.network === 'N3'
        ? $.walletAdapter.addressOf('n3', BridgeNetworkHelper.network())
        : $.walletAdapter.addressOf('neoX', BridgeNetworkHelper.network())
    )

    if (this.network === 'X') {
      return `${address.slice(0, 13)}...${address.slice(-13)}`
    }

    return !this.isLargeDesktop
      ? `${address.slice(0, 5)}...${address.slice(-5)}`
      : address
  }

  get isConnected() {
    return this.network === 'N3'
      ? $.walletAdapter.n3ConnectedWalletPlatform
      : $.walletAdapter.xConnectedWalletPlatform
  }

  get tokenIcon() {
    return this.network === 'N3'
      ? require('@/assets/img/neo.svg')
      : require('@/assets/img/neox.svg')
  }

  get tokenAlt() {
    return this.network === 'N3' ? 'neo icon' : 'neo X icon'
  }

  get tokenLabel() {
    if (this.isMobile) {
      return this.network === 'N3'
        ? this.$translate('components.BridgePanel.neoN3Mobile')
        : this.$translate('components.BridgePanel.neoX')
    }

    return this.network === 'N3'
      ? this.$translate('components.BridgePanel.neoN3')
      : this.$translate('components.BridgePanel.neoX')
  }

  get tokenClass() {
    return this.network === 'N3' ? 'bg-white' : 'bg-black'
  }

  handleConnectWallet() {
    this.$emit('connect')
  }
}
